import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { brandingConfig } from '@/config/branding';
import { useEffectiveBranding } from '@/hooks/use-effective-branding';

const DEFAULT_PRIMARY_COLOR = brandingConfig.primaryColor;

/**
 * Store primary color input component
 * Allows users to set a brand color for their store
 */
export const StorePrimaryColorInput = () => {
  const { t } = useTranslation('stores');
  const brand = useEffectiveBranding();
  const defaultColor = brand.primaryColor || DEFAULT_PRIMARY_COLOR;
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<{ primaryColor: string }>();

  const primaryColor = watch('primaryColor') || defaultColor;

  return (
    <div className="space-y-2">
      <Label htmlFor="primaryColor">{t('primaryColor.label')}</Label>
      <div className="flex items-center gap-3">
        <div className="relative">
          <input
            type="color"
            value={primaryColor}
            onChange={(e) => setValue('primaryColor', e.target.value)}
            className="h-10 w-10 cursor-pointer overflow-hidden rounded-lg border"
          />
        </div>
        <Input
          id="primaryColor"
          placeholder={defaultColor}
          {...register('primaryColor')}
          className="w-32 font-mono uppercase"
          maxLength={7}
        />
        <div
          className="h-10 flex-1 rounded-lg"
          style={{ backgroundColor: primaryColor }}
        />
      </div>
      {errors.primaryColor && <p className="text-sm text-red-500">{errors.primaryColor.message}</p>}
      <p className="text-xs text-gray-500">{t('primaryColor.helpText')}</p>
    </div>
  );
};

